import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import Loading from '../../../../../components/common/Loading';
import ORBApi from '../../../../../services/ORBApi';
import { GraphColors } from './GraphOptions';

export default function TracksRevenueGraph({ currency, filters }) {
	const [track, setTrack] = useState([]);
	const [valueTrack, setValueTrack] = useState([]);
	const [setFullNames] = useState([]);
	const [fileProcessing, setFileProcessing] = useState(0);
	const [requestSource, setRequestSource] = useState(null);

	const doSearch = () => {
		if (fileProcessing) {
			// if there is a request processing, cancel it
			ORBApi.abortRequest(requestSource);
		}
		setFileProcessing(1);
		// Get the request abort source, to be used to cancel the request if needed
		var cancelRequestSource = ORBApi.getRequestAbortSource();
		setRequestSource(cancelRequestSource);
		ORBApi.loadTrackRevenue(
			filters.startDate,
			filters.endDate,
			filters.dateType,
			filters.trackId,
			filters.contributorId,
			filters.label,
			cancelRequestSource
		)
			.then((data) => {
				setTrack(data.tracks.map((i) => i.title));
				setValueTrack(data.tracks.map((i) => i.value));
				setFullNames(data.tracks.map((i) => i.title_full));
				setFileProcessing(0);
			})
			.catch((error) => {
				if (!ORBApi.isCancel(error)) {
					// When cancelling the request, do not remove the "loading"
					setFileProcessing(0);
				}
			});
	};

	useEffect(() => {
		doSearch();
	}, [filters]);

	return (
		<div>
			{fileProcessing ? (
				<Loading className='file-loading-container' />
			) : (
				<Bar
					data={{
						labels: track,
						datasets: [
							{
								label: 'Faixas',
								data: valueTrack,
								backgroundColor: GraphColors,
							},
						],
					}}
					options={{
						plugins: {
							legend: {
								display: false,
							},
							tooltip: {
								callbacks: {
									label: function (context) {
										return context.parsed.y.toLocaleString(
											'pt-br',
											{
												style: 'currency',
												currency: currency,
											}
										);
									},
								},
							},
						},
						scales: {
							y: {
								beginAtZero: true,
								ticks: {
									callback: function (value) {
										return value.toLocaleString(
											'pt-br',
											{
												style: 'currency',
												currency: currency,
											}
										);
									},
								},
							},
						},
					}}
				/>
			)}
		</div>
	);
}
